// extracted by mini-css-extract-plugin
export default {"steps":"StepsWidget_steps__QVWfR","title":"StepsWidget_title__mnGRL","body":"StepsWidget_body__5X-FF","hide_line":"StepsWidget_hide_line__vnIST","item":"StepsWidget_item__09kAx"};